import React from 'react';

const ImageModal = ({ isOpen, onClose, imageUrl, title }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h3>{title}</h3>
        <img src={imageUrl} alt={title} />
      </div>
    </div>
  );
};

export default ImageModal; 